export default __webpack_public_path__ + "static/media/VAI.c404ae41.png";